import { render, staticRenderFns } from "./OriginMultiSelect.vue?vue&type=template&id=8caf2508&scoped=true&"
import script from "./OriginMultiSelect.vue?vue&type=script&lang=js&"
export * from "./OriginMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./OriginMultiSelect.vue?vue&type=style&index=0&id=8caf2508&lang=scss&scoped=true&"
import style1 from "./OriginMultiSelect.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caf2508",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
